import * as authorizedAgentDesignationFormService from './authorizedAgentDesignationFormService';

export function downloadAuthorizedAgentDesignationForm() {
    return authorizedAgentDesignationFormService
        .downloadAuthorizedAgentDesignationForm();
}